
import Work from "../componets/Work/Work"
import {AnimatePresence, motion } from "framer-motion";

export default function WorkPage() {
  return (
    <AnimatePresence mode="wait">
    
    <motion.div
    variants={{
      hidden: { opacity: 0, y: -50 },
      visible: { opacity: 1, y: 0 },
    }}
    initial="hidden"
    animate="visible"
    transition={{ duration: 1.2}}
     className="bg-[#ece1cf] h-screen">
      <Work />
    </motion.div>
    </AnimatePresence>
  )
}
